import React from 'react'
import Grid from '@mui/material/Grid2'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import Image from '@/components/image/Image'
import Carousel from '@/components/carousel/Carousel'
import IconButton from '@mui/material/IconButton'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import YouTubeIcon from '@mui/icons-material/YouTube'
import Divider from '@/components/divider/Divider'
import CurrentEvent from '@/components/currentEvent/CurrentEvent'

const carouselImages = [
  '/images/statics/cleaning.jpg',
  '/images/statics/fika-3.jpg',
  '/images/statics/recording.jpg',
  '/images/history/ostersjofestivalen-4.jpg',
]

const Home: React.FC = () => {
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Grid size={10}>
        <Typography
          variant="h1"
          fontWeight="700"
          sx={{
            marginBottom: 0,
            marginTop: '25px',
            fontSize: { xs: '1.5em', md: '2em' },
          }}
        >
          Välkommen till Sveriges äldsta Scoutmusikkår!
        </Typography>
        {/* <h1 style={{ marginBottom: 0 }}>Välkommen till Sveriges äldsta och enda Scoutmusikkår!</h1> */}
        <Typography
          variant="h2"
          fontWeight="700"
          sx={{
            marginTop: 0,
            fontSize: '1em',
          }}
        >
          Följ oss på Instagram{' '}
          <IconButton
            aria-label="Instagram"
            sx={{ color: '#000000' }}
            onClick={() =>
              window.open('https://www.instagram.com/scoutmusikkaren/')
            }
          >
            <InstagramIcon />
          </IconButton>
          Facebook{' '}
          <IconButton
            aria-label="Facebook"
            sx={{ color: '#000000' }}
            onClick={() =>
              window.open('https://www.facebook.com/scoutmusikkaren')
            }
          >
            <FacebookIcon />
          </IconButton>{' '}
          och Youtube{' '}
          <IconButton
            aria-label="Youtube"
            sx={{ color: '#000000' }}
            onClick={() =>
              window.open(
                'https://www.youtube.com/@KarlshamnsScoutmusikk%C3%A5r',
              )
            }
          >
            <YouTubeIcon />
          </IconButton>
        </Typography>
      </Grid>

      <Grid size={{ xs: 11, md: 10 }}>
        <Image src="/images/statics/groupimage-2024.jpg" alt="Gruppbild" />
      </Grid>

      <Divider size={{ xs: 11, md: 8 }} />

      <CurrentEvent />

      <Divider size={{ xs: 11, md: 8 }} />

      <Grid size={{ xs: 11, md: 6 }}>
        <h2>Detta är Karlshamns Scoutmusikkår</h2>
        <p style={{ textAlign: 'start' }}>
          Vi är en ideell förening där musik och gemenskap står i centrum. Vi
          spelar på konserter, parader och andra evenemang - och har roligt
          tillsammans både på och utanför scenen.
        </p>
      </Grid>
      <Grid size={{ xs: 11, md: 6 }}>
        <h2>
          <Link href="/contact">Klicka här för att kontakta oss!</Link>
        </h2>
      </Grid>

      <Divider size={{ xs: 11, md: 8 }} />

      <Grid sx={{ marginBottom: '50px' }}>
        <Carousel images={carouselImages} />
      </Grid>
    </Grid>
  )
}

export default Home
